import http from "@/axiosConfig";
import toast from "@/global/ToastConfig";

const reportsLockerRoutes = {
    DOWNLOAD_INVOICE_BY_CONCEPT: "/reports/overview-report/locker/concept-invoice",
    LIST_INVOICE_BY_CONCEPT: "/reports/overview-report/locker/concept-invoice-list",
    DOWNLOAD_COLLECTION_LOCKER: "/reports/overview-report/locker/collected",
    LIST_COLLECTION_LOCKER: "/reports/overview-report/locker/collected-list",
    PREVIEW_FREQUENCY_LOCKER: "/reports/overview-report/locker/frequency-data",
    DOWNLOAD_FREQUENCY_LOCKER:"/reports/overview-report/locker/frequency-export"
}
export default {

    downloadInvoiceByConcept(objParams) {
        return new Promise(resolve => {
            let newData = {code: -1};
            http.get(reportsLockerRoutes.DOWNLOAD_INVOICE_BY_CONCEPT, {
                params: objParams
            }).then(({data}) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    return;
                }
                newData = data;
            }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });

    },
    listInvoiceByConcept(objParams) {
        return new Promise(resolve => {
            let newData = {};
            http.get(reportsLockerRoutes.LIST_INVOICE_BY_CONCEPT, {
                params: objParams
            }).then(({data}) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    newData = data;
                    return;
                }
                if (!data.info.records || data.info.records.length === 0) {
                    toast.info("No se encontraron facturas con los criterios ingresados");
                    newData = data;
                    return;
                }
                newData = data;
            }).catch(() => toast.error("Error al consultar facturación"))
                .finally(() => resolve(newData));
        });
    },
    downloadCollection(objParams) {
        return new Promise(resolve => {
            let newData = {code: -1};
            http.get(reportsLockerRoutes.DOWNLOAD_COLLECTION_LOCKER, {
                params: objParams
            }).then(({data}) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    return;
                }
                newData = data;
            }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });

    },
    listCollection(objParams) {
        return new Promise(resolve => {
            let newData = {};
            http.get(reportsLockerRoutes.LIST_COLLECTION_LOCKER, {
                params: objParams
            }).then(({data}) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    return;
                }
                newData = data;
            }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    },
    previewFrequency(objParams) {
        return new Promise(resolve => {
            let newData = {};
            http.get(reportsLockerRoutes.PREVIEW_FREQUENCY_LOCKER, {
                params: objParams
            }).then(({data}) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    newData = data;
                    return;
                }
                if (code ===0) {
                    toast.info(data.message);
                    newData = data;
                    return;
                }
                newData = data;
            }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    },
    downloadFrequency(objParams) {
        return new Promise(resolve => {
            let newData = {code: -1};
            http.get(reportsLockerRoutes.DOWNLOAD_FREQUENCY_LOCKER, {
                params: objParams
            }).then(({data}) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    return;
                }
                newData = data;
            }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });

    },

}
